import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Notebook() {
  const menu = [
    {
      name: "January to March 2023",
      id: "Notebook-0",
    },
    {
      name: "April 2023",
      id: "Notebook-1",
    },
    {
      name: "May 2023",
      id: "Notebook-2",
    },
    {
      name: "June to July 2023",
      id: "Notebook-3",
    },
    {
      name: "August 2023",
      id: "Notebook-4",
    },
    {
      name: "September 2023",
      id: "Notebook-5",
    },
    {
      name: "October 2023",
      id: "Notebook-6",
    },
    {
      name: "November 2023",
      id: "Notebook-7",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Notebook:</p>
        <p className="subtitle" key={"Notebook-0"} id="Notebook-0">
          January to March 2023
        </p>
        <ContentCard
          content={` 
            <p>
            •  10th-27th January - Recruiting the team members of the biology group.
            </p>
            <p>
            •	Weekly - We had a team meeting to brainstorm and develop ideas for our project.
            </p>
            <p>
            •	2nd February - We communicated with our PI Cai Li to discuss the feasibility of our initial 3 ideas.
            </p>
            <p>
            •	19th February to 14th March - We settled on the topic of genetic circuit-designing software based on artificial intelligence, started writing the program proposal, and attended a lot of lectures about this.
            </p>
            <p>
            •	15th March to 31st March -  The topic of genetic circuit-designing software based on artificial intelligence was rejected by our PI Jianhua Yang for lack of innovation and we brainstormed again on metagenomic mining. In the meantime, we consulted a lot of professors.
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-1"} id="Notebook-1">
          April 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	1st April - We visited Rjmart with the intent of exploring potential collaborations.
            </p>
            <p>
            •	9th April - We settled on the new idea of developing a prokaryotic extracellular contractile injection system (eCIS) search and prediction platform based on machine learning and completed the preliminary conception of the overall experimental design and Human Practice.
            </p>
            <p>
            •	10th April to 20th April - Siying Wang drafted the iGEM meetup invitation emails and poster copywriting. Wei Xu finished the first draft of the poster for the iGEM meetup.
            </p>
            <p>
            •	13th April - Jiayuan Tian successfully reported the project proposal to President Cui of the College of Life Sciences.
            </p>
            <p>
            •	15th April - We reached out to Dr. Zhongjun Li, Associate Chief Physician in the Neurosurgery Department at Sun Yat-sen Memorial Hospital (Guangzhou) and Dr. Sixue Liu, Associate Chief Physician in the Gastroenterology Department, to seek their insights on the clinical requirements and current limitations of protein delivery systems.
            </p>
            <p>
            •	16th April - a weekly team meeting. We found two existing databases of eCISs. 
            </p>
            <p>
            •	22nd April - a weekly team meeting. We signed in the igem slack. Besides, we started to find ways to extract the features of protein and gene sequences.
            </p>
            <p>
            •	20th to 30th April - We engaged in discussions with several professors from the School of Life Sciences and the School of Pharmacy at Sun Yat-sen University. 
            </p>
            <p>
            •	28th April - We attended the New criteria freetalk raised by CCiC.
            </p>
            <p>
            •	30th April - We engaged in an online discussion with Tianqin Li, the team leader of SYSU-Software in 2019, who is currently pursuing a Ph.D. degree in Natural Language Processing at Carnegie Mellon University. 
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-2"} id="Notebook-2">
          May 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	13rd May - The team members of model group and program group were recruited.
            </p>
            <p>
            •	14th May - a weekly team meeting. We divided the verification part and assigned it to certain personnel. In addition, we mastered the method of obtaining existing eCIS data with high throughput, which act as the positive samples for machine learning.
            </p>
            <p>
            •	21st May - We took part in the 7th South China Region Meeting.
            </p>
            <p>
            •	27th May - We listened to the report of researcher Feng Jiang, a professor in eCISs and communicated with him about our project, which deepened our understanding of eCISs and noted the importance of afp13.
            </p>
            <p>
            •	28th May - We participated in the Modeling and Software Symposium raised by CCiC.
            </p>
            <p>
            •	31st May - We advanced the planning case for the iGEM meetup - AI for synbio.
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-3"} id="Notebook-3">
          June to July 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	15th June - we made a poster of relevant knowledge about eCISs to popularize biology knowledge to college students in our school.
            </p>
            <p>
            •	16th June to 20th June - We submitted the draft of the safety form and description.
            </p>
            <p>
            •	19th June - We summarized the latest research advancements on the eCISs and created a poster presentation to spread it on campus.
            </p>
            <p>
            •	4th July - We drew a plan for the assignments in summer vacation, including the wet experiment, promotion video, wiki copywriting, modeling, and Human Practice.
            </p>
            <p>
            •	7th July - We communicated with our PI Cai Li about our dry experiment.
            </p>
            <p>
            •	8th to 10th July - We took part in the 10th Conference of China iGEMer Community (CCiC).
            </p>
            <p>
            •	9th July - We participated in the CCiC to share our project and learn from others.
            </p>
            <p>
            •	13th July - We communicated with our second PI Siyuan Feng. He suggested that structural comparison may help predict the protein function. Besides, he allowed us to do wet experiments of toxin validation in his lab.
            </p>
            <p>
            •	20th July - Chaimao Hu completed the first draft of the promotion video copywriting.
            </p>
            <p>
            •	27th July - We prepare the negative samples for machine learning by random sampling. 
            </p>
            <p>
            •	28th July - We had prepared well for our iGEM Meetup - AI for Synbio and sent invitations.
            </p>
            <p>
            •	28th July - We visited Rjmart again and reached a collaboration in visualization.
            </p>
            <p>
            •	30th July - We extracted the features of sequences using MathFeather.
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-4"} id="Notebook-4">
          August 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	1st August - We recruited team members of the art group and started preparing our wiki.
            </p>
            <p>
            •	2nd August - Lerong Zhao and Jiayuan Tian raised money from Beijing Tsingke Biotech Co., Ltd. for 20kb gene synthesis for our validation.
            </p>
            <p>
            •	15th July to 18th August - Chaimao Hu went to the National Institute of Biological Sciences, Beijing together with iGEM CPU_CHINA and shared each other's projects during the exchange. 
            </p>
            <p>
            •	1st to 9th August - Learning molecular cloning in wet lab for toxin validation.
            </p>
            <p>
            •	1st to 3rd August - We compared different models under our samples, including random forest, logistic regression, and proteinBERT, and found that proteinBERT works best.
            </p>
            <p>
            •	3rd August - We reached out to Professor Jiang with the challenge of determining the boundaries of eCIS gene clusters and he suggested that the current method for determining boundaries would involve identifying proteins that are clearly annotated as non-eCIS as the boundaries. 
            </p>
            <p>
            •	4th - 13th August - Build models for each key protein including afp1/5, afp11 and afp13 and tune the parameters for the models.
            </p>
            <p>
            •	6th August - Started writing the content for our wiki.
            </p>
            <p>
            •	8th August - We consulted Jianyu Jiao about the scope of digging and he recommended a representative database - GTDB.
            </p>
            <p>
            •	1st to 10th August - Designed the logo for our Biorocket.
            </p>
            <p>
            •	9th August - We organized the 2023 SynBio Plus AI webinar.
            </p>
            <p>
            •	12th August -  First online discussion with Oxford iGEMer about AI applied to Synthetic Biology.
            </p>
            <p>
            •	15th August - Started mining in the GTDB with our models. In the meanwhile, we screened out the false positive results by structural alignment.
            </p>
            <p>
            •	16th - 17th August - Finalized the promotion video copy and shot the promotion video.
            </p>
            <p>
            •	18th August - The first draft of the home page for our wiki designed by Xin Tian.
            </p>
            <p>
            •	20th August to 9th September - Drawing video footage, dubbing, and editing the promotion video.
            </p>
            <p>
            •	19th August - Started writing the Business Plan.
            </p>
            <p>
            •	21st August - We visited the China National GeneBank (CNGB) in Shenzhen and engaged in a fruitful conversation with Dr. Yun Wang. 
            </p>
            <p>
            •	22nd to 29th August - We annotated our results for the potential toxins for the wet lab, which may act as indirect validation.
            </p>
            <p>
            •	20th to 30th August - Synthesizing the effector genes screened out from the eCISs mined out by previous research and performing wet experiments to familiarize ourselves with toxin validation and verify the feasibility of it.
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-5"} id="Notebook-5">
          September 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	2nd September - Jialu Zheng designed the typesetting for other pages of our wiki.
            </p>
            <p>
            •	5th September  - Sent orders for effector gene synthesis to Tsingke.
            </p>
            <p>
            •	11th September - Started wiki coding.
            </p>
            <p>
            •	17th September - We explored the programmability of eCISs based on the data we dug out.
            </p>
            <p>
            •	20th September to 1st October - We performed toxin validation of the data we dug out.
            </p>
            <p>
            •	23th September - We met with iGEM WHU-CHINA at Wuhan University to share our projects. 
            </p>
            <p>
            •	24th September to 5th October - Deep discussion with Oxford iGEMer Erica and we collaborated to write Investigation and Reflections on Policies for Artificial Intelligence Uses in Synthetic Biology.
            </p>
            <p>
            •	27th September - Complete the front-end and back-end development of our BioRocket software.  
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-6"} id="Notebook-6">
          October 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	11th October - Wiki free
            </p>
            <p>
            •	1st to 18th October - Make PowerPoint and our presentation video
            </p>
            <p>
            •	20th to 30th October - Prepare for the Jamboree
            </p>
              `}
        /> 
        <p className="subtitle" key={"Notebook-7"} id="Notebook-7">
          November 2023
        </p>
        <ContentCard
          content={`
            <p>
            •	2nd to 5th November - Join in the 2023 iGEM Grand Jamboree!
            </p>
            `}
        />
      </div>
      <Footer />
    </div>
  );
}
